import React from 'react';

import './no_wifi.css';

const NoWiFiSymbol = (props) => (
  <div className='no-wifi' />);

export default NoWiFiSymbol;
